<app-single-page />

<ng-template #template_details>
    <app-settings-details
        (onEscape)="emit_onEscape();"
        (onPageLoaded)="emit_onPageLoaded()"
    />
</ng-template>

<ng-template #template_footerLeft>
    <app-button-navigation (btnClick)="emit_onEscape()">
        <app-icon name="arrow-left" />
    </app-button-navigation>
</ng-template>
